import { promiseState } from "./promise-state.js";
import type { MakeTrackedPromise } from "./types/MakeTrackedPromise";

export const makeTrackedPromise: MakeTrackedPromise = ({
  action,
  asyncFunction,
  onFulfilled,
  onRejected,
  onSettled,
}) => {
  return {
    action,

    get isBlank() {
      return this.state === promiseState.blank;
    },

    get isFulfilled() {
      return this.state === promiseState.fulfilled;
    },

    get isPending() {
      return this.state === promiseState.pending;
    },

    get isRejected() {
      return this.state === promiseState.rejected;
    },

    get isSettled() {
      return (
        this.state === promiseState.fulfilled ||
        this.state === promiseState.rejected
      );
    },

    reason: undefined,

    reset() {
      this.state = promiseState.blank;

      this.value = undefined;

      this.reason = undefined;

      this.settledAt = undefined;
    },

    resolve(value) {
      this.state = promiseState.fulfilled;

      this.value = value;

      onFulfilled?.(value);

      this.settledAt = new Date();

      onSettled?.();
    },

    run(input) {
      const { promise, resolve } = Promise.withResolvers<boolean>();

      this.value = undefined;

      this.reason = undefined;

      this.settledAt = undefined;

      this.state = promiseState.pending;

      asyncFunction(input)
        .then((value) => {
          this.state = promiseState.fulfilled;

          this.value = value;

          onFulfilled?.(value);

          resolve(true);
        })

        .catch((reason) => {
          this.state = promiseState.rejected;

          this.reason = reason;

          onRejected?.(reason);

          resolve(false);
        })

        .finally(() => {
          this.settledAt = new Date();

          onSettled?.();
        });

      return promise;
    },

    settledAt: undefined,

    state: promiseState.blank,

    value: undefined,
  };
};
